import { Dialog, Button, DialogContent, DialogActions, DialogContentText} from "@mui/material"
import { useGetIdentity, useRedirect, useTranslate } from "react-admin"

const AddNumberRangeDialog = () => {
  
  const translate = useTranslate()
  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()

  if(isLoading || !identity) return null


  const handleConfig = () => {
    redirect(`/numberRanges/create?name=Standard`)
  }

  return (
    <>
      <Dialog 
        open={true} 
      >
        <DialogContent>
          <DialogContentText>
            {translate('resources.numberRanges.dialogs.add')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfig} >{translate('resources.numberRanges.actions.add')}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AddNumberRangeDialog